import { render, staticRenderFns } from "./BMBlogTile.vue?vue&type=template&id=12524638&"
import script from "./BMBlogTile.vue?vue&type=script&lang=js&"
export * from "./BMBlogTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BMBlogTile.vue"
export default component.exports